import {
  CheckCircleIcon,
  QuestionMarkCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XCircleIcon,
  HomeIcon,
  UsersIcon,
  Cog6ToothIcon,
  MagnifyingGlassIcon,
  PlusIcon,
  PencilIcon,
  TrashIcon,
  ArrowDownTrayIcon,
  ArrowUpTrayIcon,
  EyeIcon,
  EyeSlashIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  ChevronDownIcon,
  Bars3Icon,
  XMarkIcon,
  BellIcon,
  StarIcon,
  HeartIcon,
  ShoppingCartIcon,
  ArchiveBoxIcon,
  ChartBarIcon,
  CalendarIcon,
  ClockIcon,
  EnvelopeIcon,
  PhoneIcon,
  MapPinIcon,
  FunnelIcon,
  ArrowPathIcon
} from "@heroicons/vue/24/outline";

// Heroicons 映射表（使用 outline 樣式）
export const HeroIcons = {
  // 狀態圖示
  CheckCircleIcon,
  QuestionMarkCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XCircleIcon,
  
  // 導航圖示
  HomeIcon,
  UsersIcon,
  Cog6ToothIcon,
  MagnifyingGlassIcon,
  Bars3Icon,
  XMarkIcon,
  
  // 動作圖示
  PlusIcon,
  PencilIcon,
  TrashIcon,
  ArrowDownTrayIcon,
  ArrowUpTrayIcon,
  EyeIcon,
  EyeSlashIcon,
  ArrowPathIcon,
  
  // 方向圖示
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  ChevronDownIcon,
  
  // 通知與社交
  BellIcon,
  StarIcon,
  HeartIcon,
  
  // 商務圖示
  ShoppingCartIcon,
  ArchiveBoxIcon,
  ChartBarIcon,
  
  // 時間與聯絡
  CalendarIcon,
  ClockIcon,
  EnvelopeIcon,
  PhoneIcon,
  MapPinIcon,
  
  // 其他功能
  FunnelIcon
};

// 預設圖示（當找不到指定圖示時使用）
export const DefaultHeroIcon = QuestionMarkCircleIcon;
